import React from "react";

export default function HomePage() {
    return (
        <>
            <div>Bientôt disponible...</div>
        </>
    );
}